import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';

import { IProperty } from '@shared/models/properties';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-shared-property-list',
  templateUrl: './property-list.component.html',
  styleUrls: ['./property-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyListComponent implements OnInit {
  @Input({ required: true }) property?: IProperty;
  @Input({ required: true }) isLoggedIn = false;
  @Input({ required: true }) shareModalOpen = false;
  @Input() lpSection?: string;
  @Output() openShareModal = new EventEmitter<IProperty | undefined>();

  protected thumbnail = '/assets/images/property-no-image.svg';
  protected image?: string;

  protected routerLink: any[] = [];
  protected queryParams?: Record<string, string>;

  ngOnInit(): void {
    if (this.property?.images?.length) {
      this.thumbnail = this.property.images[0].thumbnail.url;
      this.image = this.property.images[0].small.url;
    } else {
      this.image = '/assets/images/property-no-image.svg';
    }

    const fromRebuilt =
      this.property?.organization?.id === environment.rebuiltOrgId;

    const path =
      !fromRebuilt && this.property?.organization?.shortName
        ? [
            '/o',
            this.property.organization.shortName.toLowerCase(),
            'properties',
            this.property.id,
          ]
        : ['/properties', this.property?.id];

    this.routerLink = path;

    if (this.lpSection) {
      this.queryParams = { 'lp-section': this.lpSection };
    }
  }
}
